import React, { useEffect, useState } from 'react';
import { useRef } from 'react';

const Dropdown = ({ options, onSelect }) => {
  const [isOpen, setIsOpen] = useState(false);

  const dropdownRef = useRef(null)

  const handleToggle = () => {
    // setIsOpen(!isOpen);
    setIsOpen((prev) => !prev)
  };

  const handleOptionClick = (option) => {
    onSelect(option);
    setIsOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) =>{
      if(dropdownRef.current && !dropdownRef.current.contains(event.target)){
        setIsOpen(false)
      }
    }
    document.addEventListener('mousedown',handleClickOutside)
    return () => {
      document.removeEventListener('mousedown',handleClickOutside)
    }
  },[])

  return (
    <div ref={dropdownRef}
     className="relative inline-block text-left ">
      <div>
        <button
          type="button"
          onClick={handleToggle}
          className=" inline-flex justify-center items-center w-6 h-6 rounded-full bg-gray-200 hover:bg-gray-300 focus:outline-none"
          aria-haspopup="true"
          aria-expanded={isOpen ? 'true' : 'false'}
        >
          {/* Icon for dropdown */}
          <svg
            className="h-4 w-6 text-gray-600"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M19 9l-7 7-7-7"
            />
          </svg>
        </button>
      </div>

      {/* Dropdown menu */}
      {isOpen && (
        <div className="origin-top-right absolute right-6 mt-1 w-24 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none" role="menu" aria-orientation="vertical">
          <div className="py-1" role="none">
            {options.map((option, index) => (
              <button
                key={index}
                onClick={() => handleOptionClick(option)}
                className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 w-full text-left"
                role="menuitem"
              >
                {option}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default Dropdown;
